import React, { FunctionComponent } from 'react';

import { Helmet } from 'react-helmet';
import join from 'url-join';

import { SlugFragmentResponse } from '../../fragments/slug';
import { DEFAULT_LOCALE } from '../Seo/get-lang-from-locale';
import useSiteMetadata from '../Seo/useSiteMetadata';

export interface LangRef {
  i18n_lang?: string;
  slug?: SlugFragmentResponse;
}

interface HrefLangProps {
  refs?: LangRef[];
}

const HrefLang: FunctionComponent<HrefLangProps> = (props) => {
  const { refs = [] } = props;
  const { siteUrl } = useSiteMetadata();

  const renderRef = (ref: LangRef) => {
    const lang = ref.i18n_lang || DEFAULT_LOCALE;
    const { slug } = ref;
    if (!slug?.current) {
      return null;
    }

    const href = join(siteUrl, slug.current);
    return <link key={lang} rel="alternate" hrefLang={lang.replace('_', '-').toLowerCase()} href={href} />;
  };

  return <Helmet>{refs.map(renderRef)}</Helmet>;
};

export default HrefLang;
